module.exports = __webpack_public_path__ + "img/97.06cb44fe.jpg";